module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Usuários")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_vm._m(1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal ng-pristine ng-valid-maxlength ng-valid-minlength ng-valid-mask ng-valid-parse ng-valid-date ng-valid-max ng-valid ng-valid-required",
    attrs: {
      "name": "user",
      "novalidate": ""
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    attrs: {
      "ng-class": "{ 'has-error' : frmRegUserFbb.$submitted && frmRegUserFbb.userName.$error.required }"
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userName),
      expression: "user.userName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "userName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "userName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.user.userType === 'ENTIDADE') ? _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('cpf')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "cpf"
    }
  }, [_vm._v("CPF:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.cpf),
      expression: "user.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        cpf: true
      }),
      expression: "{cpf: true}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cpf",
      "type": "text"
    },
    domProps: {
      "value": (_vm.user.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "cpf", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cpf')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-isolate-scope ng-valid-maxlength ng-valid-minlength ng-not-empty ng-valid ng-valid-required",
    attrs: {
      "name": "email",
      "type": "text",
      "minlength": "1",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (this.$root.authorize('usuario-fundacao-atribuir-perfil')) ? _c('div', {
    staticClass: "ng-scope ng-isolate-scope"
  }, [_c('fieldset', [_c('legend', [_vm._v("Perfis")]), _vm._v(" "), _c('div', {
    staticClass: "well well-sm no-shadow animated fadeInDownOutUp ng-pristine ng-valid-mask ng-invalid ng-invalid-required ng-valid-maxlength ng-valid-max ng-valid-date ng-hide"
  }, [_c('div', {
    staticClass: "form-group required"
  }, [_c('label', {
    staticClass: "control-label col-sm-2"
  }, [_vm._v("Adicionar o perfil:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4",
    class: {
      'has-error': _vm.errors.first('profile')
    }
  }, [_c('profiles', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "name": "profile",
      "propsProfile": _vm.profileConstraint.profile
    },
    on: {
      "profileSelected": function($event) {
        _vm.profileConstraint.profile = $event
      }
    },
    model: {
      value: (_vm.profileConstraint.profile),
      callback: function($$v) {
        _vm.$set(_vm.profileConstraint, "profile", $$v)
      },
      expression: "profileConstraint.profile"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('profile')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required",
    class: {
      'has-error': _vm.errors.first('initialDate')
    }
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "dt_inicial"
    }
  }, [_vm._v("Data inicial:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileConstraint.initialDate),
      expression: "profileConstraint.initialDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "initialDate"
    },
    domProps: {
      "value": (_vm.profileConstraint.initialDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileConstraint, "initialDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('initialDate')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-2",
    attrs: {
      "for": "dt_final"
    }
  }, [_vm._v("Data final:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.profileConstraint.inactivateDate),
      expression: "profileConstraint.inactivateDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "inactivateDate",
      "type": "date"
    },
    domProps: {
      "value": (_vm.profileConstraint.inactivateDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.profileConstraint, "inactivateDate", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-sm-10 col-sm-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onAdd()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Incluir")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.items,
      "hover": _vm.hover,
      "fields": _vm.fields,
      "filter": _vm.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Preencha o filtro acima!",
      "table-layout:": "",
      "fixed": ""
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "active",
      fn: function(row) {
        return [_c('i', {
          class: ['fa fa-circle ', row.value == 'true' ? 'text-green' : 'text-red'],
          attrs: {
            "aria-hidden": "true"
          }
        })]
      }
    }, {
      key: "createdAt",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "profile.createdAt",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', [_c('g-button-ujarak', {
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "disabled": !_vm.$root.authorize('perfil-atribuir-usuario')
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.onEdit(_vm.p)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-square-o",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v("  Editar\n                              ")]), _vm._v(" "), _c('g-button-ujarak', {
          attrs: {
            "color": "warning",
            "size": "button--size-ss",
            "disabled": !_vm.$root.authorize('perfil-atribuir-usuario')
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.onDelete(_vm.p)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v(" Excluir")])])], 1)]
      }
    }], null, false, 2408969140)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.totalRows,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])], 1)])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "success",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onSave($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClean($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Limpar")]), _vm._v(" "), _c('g-button-moema', {
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "to": {
        name: 'cadastro-usuarios-lista'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])], 1)])])])])])])])]), _vm._v("\n'"), _c('vue-snotify')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro de usuário: Fundação")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5799c3a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/usuario/EditaUsuario_old.vue
// module id = 1967
// module chunks = 1